module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Ladder/Fire-Ladder.svg";